import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
  import { contactStatus } from "@/helpers/contactStatus";
  import { ContactStatusInterface } from "@/types/ContactInterface";
  import { getContactStatusClass } from "@/helpers/status";
  import { ContactStatus } from "@/enums/ContactStatus";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ContactStatusBadge',
  props: {
    contactStatuses: {
      type: Array,
      required: true,
    },
    estateId: {
      type: String,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const type = computed(() => {
    return contactStatus(
      (props.contactStatuses || []) as ContactStatusInterface[],
      props.estateId
    );
  });

const __returned__ = { props, type, computed, onMounted, ref, get contactStatus() { return contactStatus }, get ContactStatusInterface() { return ContactStatusInterface }, get getContactStatusClass() { return getContactStatusClass }, get ContactStatus() { return ContactStatus } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})